
export default {
  COGNITO_USER_POOL_ID: 'ap-northeast-1_MI6mmRo3E',
  API_URL: 'https://9yw384oche.execute-api.ap-northeast-1.amazonaws.com/api',
  COGNITO_IDENTITY_POOL_ID: 'ap-northeast-1:dd64d784-fe1e-4b60-b573-f000dc0c1c9f',
  AWS_IOT_ENDPOINT: 'a5fthwbfc19ut-ats.iot.ap-northeast-1.amazonaws.com'
}
